module.exports = __webpack_public_path__ + "static/media/4-nutrition-assessment-and-guidance@3x.edc413ea.png";